import { render, staticRenderFns } from "./footerPhone.vue?vue&type=template&id=34ecab2c&scoped=true&lang=pug&"
import script from "./footerPhone.vue?vue&type=script&lang=ts&"
export * from "./footerPhone.vue?vue&type=script&lang=ts&"
import style0 from "./footerPhone.vue?vue&type=style&index=0&id=34ecab2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ecab2c",
  null
  
)

export default component.exports